<template>
    <div>
        <HeadView
            logo
            :province="province"
            @closeProvince="closeProvince"
        ></HeadView>
        <BannerView :province="province"></BannerView>
        <div class="main">
            <!-- <div class="mt-10 first fr-ac-jsb" style="height: 70px">
                <div
                    class="flex-1 left fr-ac-jc"
                    @click="
                        pathInnerClick({
                            link: `/fill/fill_search`,
                        })
                    "
                >
                    <div class="mainSearch mr-20 fr-ac pl-20">
                        <p>请输入关键字搜索</p>
                    </div>
                    <div class="mainButton fr-ac-jc">搜索</div>
                </div>
                <div
                    class="ml-15 fr-ac-jc bold right"
                    v-for="(item, ind) in tab_list"
                    :key="ind"
                    @click="tabListClick(item)"
                >
                    开通{{ item.title }}系统
                </div>
            </div> -->
            <div
                class="mt-10 second"
                :class="`grid-${T_A.length}`"
                v-if="T_A.length !== 0"
            >
                <img
                    v-for="(item, ind) in T_A"
                    :key="ind"
                    :src="item.img"
                    class="WH-100"
                    @click="pathOutClick(item)"
                />
            </div>
            <div class="mt-10 third grid-7 bg-white">
                <div
                    v-for="item in tabList"
                    :key="item.id"
                    class="fr-ac-jc pt-15 pb-15"
                    @click="tabListClick(item)"
                >
                    <img
                        :src="'https://file.gkzzd.cn' + item.img"
                        style="width: 15px; height: 15px"
                    />
                    <div class="ml-5">{{ item.title }}</div>
                </div>
            </div>
            <div class="mt-10 fourth" :class="`grid-3`">
                <div class="bg-white">
                    <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                        <div class="title fs-16">招考公告</div>
                        <div
                            class="fs-12"
                            @click="
                                pathInnerClick({
                                    link: `/fill/fill_news?title=招考公告`,
                                })
                            "
                        >
                            查看更多{{ "\u003E" }}
                        </div>
                    </div>
                    <el-popover
                        placement="top"
                        v-for="(item, ind) in zkgg"
                        :key="ind"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="!!disabledListZkgg[ind]"
                    >
                        <div
                            slot="reference"
                            class="fr-ac-jsb px-15 py-5"
                            @click="detailClick(item.id)"
                        >
                            <img
                                :src="ICON"
                                style="width: 12px; height: 14px"
                            />
                            <div
                                ref="titleItem_zkgg"
                                class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                            >
                                {{ item.title }}
                            </div>
                            <div class="color-99 fs-13 w-24 t-c">
                                {{ item.publishtime }}
                            </div>
                        </div>
                    </el-popover>
                </div>
                <div class="bg-white">
                    <div
                        class="fr-ac-jsb pr-29 title_box mb-5"
                        style="border: none"
                    >
                        <div class="fr-ac">
                            <div
                                v-for="(item, ind) in tab_lisr"
                                :key="ind"
                                :class="
                                    tab_r_active == item.title
                                        ? 'tab_r_active'
                                        : 'tab_lisr'
                                "
                                @click="tab_r_click(item.title)"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                        <div
                            class="fs-12"
                            @click="
                                pathInnerClick({
                                    link: `/fill/fill_news?title=${tab_r_active}`,
                                })
                            "
                        >
                            查看更多{{ "\u003E" }}
                        </div>
                    </div>
                    <div
                        class="ellipsis-1 bold py-2 px-20"
                        style="color: red"
                        @click="detailClick(ttxw_top.id)"
                    >
                        {{ ttxw_top.title }}
                    </div>
                    <el-popover
                        placement="top"
                        v-for="(item, ind) in ttxw"
                        :key="ind"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="!!disabledListTtxw[ind]"
                    >
                        <div
                            slot="reference"
                            class="fr-ac-jsb px-15 py-5"
                            @click="detailClick(item.id)"
                        >
                            <img
                                :src="ICON"
                                style="width: 12px; height: 14px"
                            />
                            <div
                                ref="titleItem_ttxw"
                                class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                            >
                                {{ item.title }}
                            </div>
                            <div class="color-99 fs-13 w-24 t-c">
                                {{ item.publishtime }}
                            </div>
                        </div>
                    </el-popover>
                </div>
                <div class="bg-white">
                    <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                        <div class="title fs-16">热门专题</div>
                        <div
                            class="fs-12"
                            @click="
                                pathInnerClick({
                                    link: `/fill/fill_news?title=热门专题`,
                                })
                            "
                        >
                            查看更多{{ "\u003E" }}
                        </div>
                    </div>
                    <el-popover
                        placement="top"
                        v-for="(item, ind) in rmzt"
                        :key="ind"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="!!disabledListRmzt[ind]"
                    >
                        <div
                            slot="reference"
                            class="fr-ac-jsb px-15 py-5"
                            @click="
                                pathInnerClick({
                                    link: `/school/special_subject?id=${item.id}`,
                                })
                            "
                        >
                            <img
                                :src="ICON"
                                style="width: 12px; height: 14px"
                            />
                            <div
                                ref="titleItem_rmzt"
                                class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                            >
                                {{ item.title }}
                            </div>
                            <div class="color-99 fs-13 w-24 t-c">
                                {{ item.publishtime }}
                            </div>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="mt-10 fifth" :class="`grid-4`" v-if="A.length !== 0">
                <img
                    v-for="(item, ind) in A"
                    :key="ind"
                    :src="item.img"
                    class="WH-100"
                    @click="pathOutClick(item)"
                />
            </div>
            <div
                class="mt-10 sixth bg-white"
                :class="`grid-${text_link.length}`"
            >
                <div
                    v-for="(item, ind) in text_link"
                    :key="ind"
                    class="my-18 fs-20 bold t-c border"
                    @click="pathOutClick(item)"
                >
                    {{ item.text }}
                </div>
            </div>
            <div class="mt-10 seventh bg-white">
                <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                    <div class="title fs-20">院校直通车</div>
                    <div
                        class="fs-16"
                        @click="
                            pathInnerClick({
                                link: `/fill/fill_school`,
                            })
                        "
                    >
                        查看更多{{ "\u003E" }}
                    </div>
                </div>
                <div class="pt-20 pb-4 px-29">
                    <div class="newBus">
                        <div
                            v-for="(item, ind) in yx_bus_new"
                            :key="ind"
                            class="py-5 t-c title"
                            :class="
                                yx_bus == item.province ? 'title_active' : ''
                            "
                            @mouseover="newbusMove(item)"
                        >
                            {{ item.province }}
                        </div>
                    </div>
                    <div
                        class="grid-5 px-20 py-10"
                        style="gap: 5px; cursor: pointer"
                    >
                        <div
                            v-for="(item, ind) in yx_bus_school"
                            :key="ind"
                            class="fs-12 py-3 hover"
                            :style="{ color: item.is_red == 1 ? 'red' : '' }"
                            @click="
                                pathInnerClick({
                                    link: `/school/school_index?school_id=${item.school_id}`,
                                    ...item,
                                })
                            "
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-10 eighth grid-4" v-if="B.length !== 0">
                <img
                    v-for="(item, ind) in B"
                    :key="ind"
                    :src="item.img"
                    class="WH-100"
                    @click="pathOutClick(item)"
                />
            </div>
            <div class="mt-10 ninth fr-jsb">
                <div class="flex-1 grid-2" style="padding-right: 1%">
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">院校介绍</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=院校介绍`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in yxjs"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListYxjs[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_yxjs"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">历年分数</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=历年分数`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in lnfs"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListLnfs[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_lnfs"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">招生计划</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=招生计划`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in zsjh"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListZsjh[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_zsjh"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">招生章程</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=招生章程`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in zszc"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListZszc[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_zszc"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>

                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">硕士招生</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=硕士招生`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in sszs"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListSszs[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_sszs"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">宿舍环境</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=宿舍环境`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in sshj"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListSshj[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_sshj"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">门槛分数</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=门槛分数`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in mkfs"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListMkfs[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_mkfs"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-5">
                        <div class="fr-ac-jsb px-29 py-10 title_box mb-5">
                            <div class="title fs-16">优势专业</div>
                            <div
                                class="fs-12"
                                @click="
                                    pathInnerClick({
                                        link: `/fill/fill_news?title=优势专业`,
                                    })
                                "
                            >
                                查看更多{{ "\u003E" }}
                            </div>
                        </div>
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in yszy"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledListYszy[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15 py-5"
                                @click="detailClick(item.id)"
                            >
                                <img
                                    :src="ICON"
                                    style="width: 12px; height: 14px"
                                />
                                <div
                                    ref="titleItem_yszy"
                                    class="flex-1 ellipsis-1 fs-13 titleItem px-8"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
                <div class="w-15 bg-white px-35">
                    <div
                        v-for="(item, ind) in tabList"
                        :key="ind"
                        class="fr-ac pt-20"
                        @click="tabListClick(item)"
                    >
                        <el-image
                            :src="'https://file.gkzzd.cn' + item.img"
                        ></el-image>
                        <div class="ml-5">{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <div class="my-10 tenth bg-white">
                <div class="fr-ac-jsb px-29 py-15 title_box">
                    <div class="title">查试卷</div>
                    <div
                        @click="
                            pathInnerClick({
                                link: `/fill/fill_paper`,
                            })
                        "
                    >
                        查看更多{{ "\u003E" }}
                    </div>
                </div>
                <div class="px-20 py-20">
                    <div class="fr-ac mb-20">
                        <div
                            v-for="(item, ind) in sjList"
                            :key="ind"
                            class="px-15 py-8 radius-4 mr-5"
                            :class="sjActive == item.title ? 'sjList' : ''"
                            @click="sjListClick(item.title)"
                        >
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="grid-2">
                        <el-popover
                            placement="top"
                            v-for="(item, ind) in csj"
                            :key="ind"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="!!disabledList[ind]"
                        >
                            <div
                                slot="reference"
                                class="fr-ac-jsb px-15"
                                @click="detailClick(item.id)"
                            >
                                <div
                                    ref="titleItem_csj"
                                    class="flex-1 ellipsis-1 fs-13 titleItem"
                                >
                                    {{ item.title }}
                                </div>
                                <div class="color-99 fs-13 w-18 t-c">
                                    {{ item.publishtime }}
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>
        <DialogView :value="showTips" width="30">
            <template #dialogMain>
                <div class="fr-ac-jsb">
                    <p class="fs-16">温馨提示</p>
                    <p class="fs-24" @click.stop="showTips = false">×</p>
                </div>
                <div class="t-c pt-30 pb-10">{{ showTipsContent }}</div>
            </template>
            <template #dialogFoot>
                <div class="fr-ac-jc">
                    <div
                        class="provinceConfirm px-50 py-8"
                        @click.stop="showTips = false"
                    >
                        {{ showTipsButton }}
                    </div>
                </div>
            </template>
        </DialogView>
    </div>
</template>
<script>
import {
    homepage_archivesList,
    homepage_homePageAd,
    homepage_foot,
    getBusinessProvince,
    getAdsClick,
} from "@/utils/api";
import { getCookie } from "@/utils/common";
import { Message } from "element-ui";

export default {
    data() {
        const province = getCookie("province");
        const province_id = getCookie("province_id");
        return {
            province: province ? province : "",
            province_id: province_id ? province_id : "",
            year: new Date().getFullYear(),
            showDialog: false,
            tabList: [
                {
                    id: 1,
                    title: "查大学",
                    img: "/www/gkzzd/uploads/20250114/7b1ae133d8e0a4af4fc736a9790bbf7c.png",
                    path: "/fill/fill_school",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 2,
                    title: "查专业",
                    img: "/www/gkzzd/uploads/20250114/73d440bef01831182e8b5d637e3f4db9.png",
                    path: "/fill/fill_speciality",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 5,
                    title: "查试卷",
                    img: "/www/gkzzd/uploads/20250114/a1e9e9331fb690d0ae1f79fb0965540a.png",
                    path: "/fill/fill_paper",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 3,
                    title: "选科系统",
                    img: "/www/gkzzd/uploads/20250114/7037bad37f18e2837a2fe7dcaff35527.png",
                    path: "/fill/fill_optional",
                    is_open: false,
                    is_vip: true,
                    business: "选科系统",
                },
                {
                    id: 4,
                    title: "模拟填报",
                    img: "/www/gkzzd/uploads/20250114/ba6ea7435f8dc8618f65cd38fbe8ca05.png",
                    path: "/fill/fill_index",
                    is_open: false,
                    is_vip: false,
                    business: "模拟填报",
                },
                {
                    id: 6,
                    title: "测一测",
                    img: "/www/gkzzd/uploads/20250114/8d6db3dc8ebba842741e93ce99e9ea5c.png",
                    path: "",
                    is_open: false,
                    is_vip: false,
                    business: "测一测",
                },
                {
                    id: 7,
                    title: "查录取",
                    img: "/www/gkzzd/uploads/20250114/19d0138e6c21489b9e06cad8a09f9d8f.png",
                    path: "",
                    is_open: true,
                    is_vip: true,
                    business: "查录取",
                },
            ],
            tab_list: [
                {
                    id: 4,
                    title: "模拟填报",
                    img: "/www/gkzzd/uploads/20250114/ba6ea7435f8dc8618f65cd38fbe8ca05.png",
                    path: "/fill/fill_index",
                    is_open: false,
                    is_vip: false,
                    business: "模拟填报",
                },
            ],
            sjList: [
                { title: "最新" },
                { title: "语文" },
                { title: "数学" },
                { title: "英语" },
                { title: "物理" },
                { title: "化学" },
                { title: "生物" },
                { title: "政治" },
                { title: "地理" },
                { title: "历史" },
                // { title: "文数", },
                // { title: "理数", },
                // { title: "文综", },
                // { title: "理综", },
                { title: "日语" },
                { title: "其他" },
            ],
            sjActive: "最新",
            disabledList: [],
            disabledListYxjs: [],
            disabledListZkgg: [],
            disabledListTtxw: [],
            disabledListRmzt: [],
            disabledListLnfs: [],
            disabledListZsjh: [],
            disabledListZszc: [],
            disabledListSszs: [],
            disabledListSshj: [],
            disabledListMkfs: [],
            disabledListYszy: [],
            ICON: `${process.env.VUE_APP_IMG_URL}/www/gkzzd/uploads/20241023/6e44054dfbdf1ad852b7cf061de2076c.png`,
            tab_lisr: [{ title: "头条新闻" }, { title: "院校动态" }],
            tab_r_active: "头条新闻",
            yx_bus: "闽",
            yx_bus_school: [],
            showTips: false,
            showTipsContent: "",
            showTipsButton: "",
        };
    },
    computed: {
        list() {
            return this.$store.state.page_one || [];
        },
        T_A() {
            return this.$store.state.page_one.list_ad.T_A || [];
        },
        A() {
            return this.$store.state.page_one.list_ad.A || [];
        },
        text_link() {
            return this.$store.state.page_one.list_ad.text_link || [];
        },
        B() {
            return this.$store.state.page_one.list_ad.B || [];
        },
        csj() {
            return this.$store.state.page_one.list_csj || [];
        },
        yx_bus_new() {
            return this.$store.state.page_one.list_ad.yx_bus_new || [];
        },
        zkgg() {
            return this.$store.state.page_one.list_zkgg || [];
        },
        ttxw() {
            return this.$store.state.page_one.list_ttxw || [];
        },
        ttxw_top() {
            return this.$store.state.page_one.list_ttxw_top || {};
        },
        rmzt() {
            return this.$store.state.page_one.list_rmzt || [];
        },
        yxjs() {
            return this.$store.state.page_one.list_yxjs || [];
        },
        lnfs() {
            return this.$store.state.page_one.list_lnfs || [];
        },
        zsjh() {
            return this.$store.state.page_one.list_zsjh || [];
        },
        zszc() {
            return this.$store.state.page_one.list_zszc || [];
        },
        sszs() {
            return this.$store.state.page_one.list_sszs || [];
        },
        sshj() {
            return this.$store.state.page_one.list_sshj || [];
        },
        mkfs() {
            return this.$store.state.page_one.list_mkfs || [];
        },
        yszy() {
            return this.$store.state.page_one.list_yszy || [];
        },
    },
    watch: {
        csj() {
            this.$nextTick(() => this.checkEllipsis());
        },
        yxjs() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_yxjs", "disabledListYxjs")
            );
        },
        zkgg() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_zkgg", "disabledListZkgg")
            );
        },
        ttxw() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_ttxw", "disabledListTtxw")
            );
        },
        rmzt() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_rmzt", "disabledListRmzt")
            );
        },
        lnfs() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_lnfs", "disabledListLnfs")
            );
        },
        zsjh() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_zsjh", "disabledListZsjh")
            );
        },
        zszc() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_zszc", "disabledListZszc")
            );
        },
        sszs() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_sszs", "disabledListSszs")
            );
        },
        sshj() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_sshj", "disabledListSshj")
            );
        },
        mkfs() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_mkfs", "disabledListMkfs")
            );
        },
        yszy() {
            this.$nextTick(() =>
                this.checkEllipsis("titleItem_yszy", "disabledListYszy")
            );
        },
        yx_bus_new: {
            handler(newVal) {
                // yx_bus_new 从 store 拿到后,取第一个的 school
                this.yx_bus_school = (newVal[0] && newVal[0].school) || [];
            },
            immediate: true, // 首次也执行
        },
    },
    // 公共数据拉取逻辑:SSR(asyncData)和客户端(refreshData)共用
    // 不依赖 this,所有数据通过参数传入
    async fetchData({ store, province, province_id }) {
        const sf = province || "";
        const pid = province_id || "";

        const date = new Date().getFullYear();
        const getParameter = (type, limit, paper_subject) => ({
            province_id: pid,
            test_year: date,
            type,
            limit,
            channel_id: "",
            paper_subject,
            page: "",
            test_type: "",
            test_grade: "",
            title: "",
            get_total: 0,
        });
        const setStore = (value, type) => {
            store.commit("SET_PAGE_LIST", { data: value, type });
        };

        // 并发拉取所有列表(8 个 archivesList + 3 个其他)
        const [
            res2,
            res3,
            res4,
            res5,
            res6,
            res7,
            res8,
            res9,
            res10,
            res11,
            res12,
            res13,
            res14,
            res15,
            res16,
        ] = await Promise.all([
            homepage_archivesList(getParameter("查试卷", 20, "最新")),
            homepage_archivesList(getParameter("招考公告", 9)),
            homepage_archivesList(getParameter("热门专题", 9)),
            homepage_archivesList(getParameter("头条新闻", 8)),
            homepage_archivesList(getParameter("院校介绍", 6)),
            homepage_archivesList(getParameter("历年分数", 6)),
            homepage_archivesList(getParameter("招生计划", 6)),
            homepage_archivesList(getParameter("招生章程", 6)),
            homepage_homePageAd({ sf }),
            homepage_foot({}),
            getBusinessProvince({}),
            homepage_archivesList(getParameter("硕士招生", 6)),
            homepage_archivesList(getParameter("宿舍环境", 6)),
            homepage_archivesList(getParameter("门槛分数", 6)),
            homepage_archivesList(getParameter("优势专业", 6)),
        ]);

        setStore(res2.data.list, "csj");
        setStore(res3.data.list, "zkgg");
        setStore(res4.data.list, "rmzt");
        setStore(res5.data.list, "ttxw");
        setStore(res5.data.top, "ttxw_top");
        setStore(res6.data.list, "yxjs");
        setStore(res7.data.list, "lnfs");
        setStore(res8.data.list, "zsjh");
        setStore(res9.data.list, "zszc");
        setStore(res10.data, "ad");
        setStore(res11.data, "foot");
        setStore(res12.data, "province");
        setStore(res13.data.list, "sszs");
        setStore(res14.data.list, "sshj");
        setStore(res15.data.list, "mkfs");
        setStore(res16.data.list, "yszy");
    },
    async asyncData({ store }) {
        // SSR 阶段:entry.server.js 调 c.asyncData({store}),this = c(组件定义对象)
        // c.fetchData 存在,所以 this.fetchData 可调用
        const province = getCookie("province") || "";
        const province_id = getCookie("province_id") || "";
        await this.fetchData({ store, province, province_id });
    },
    methods: {
        getParameter(type, limit, paper_subject = "最新") {
            return {
                province_id: this.province_id,
                test_year: this.year,
                type,
                limit,
                channel_id: "",
                paper_subject,
                page: "",
                test_type: "",
                test_grade: "",
                title: "",
                get_total: 0,
            };
        },
        // 客户端刷新:用当前 this 的省份(用户刚选完的)
        async refreshData() {
            await this.$options.fetchData({
                store: this.$store,
                province: this.province,
                province_id: this.province_id,
            });
        },
        closeProvince(val1, val2) {
            this.province = val1;
            this.province_id = val2;
            this.$nextTick(() => {
                this.SETTABLIST();
                // 选完省份后重新拉取数据(省份变化会影响列表内容)
                this.refreshData();
            });
        },
        checkEllipsis(refName = "titleItem_csj", key = "disabledList") {
            // 检测指定 ref 的每个元素是否溢出(有省略号),没溢出的禁用 popover
            // ellipsis-1 用 -webkit-box + line-clamp,溢出方向是垂直,用 scrollHeight vs clientHeight
            const refs = this.$refs[refName];
            if (!refs) return;
            const arr = Array.isArray(refs) ? refs : [refs];
            this[key] = arr.map((el) => {
                if (!el) return false;
                return el.scrollHeight <= el.clientHeight;
            });
        },
        async sjListClick(val) {
            this.sjActive = val;
            const res = await homepage_archivesList(
                this.getParameter("查试卷", 20, val)
            );
            this.$store.commit("SET_PAGE_LIST", {
                data: res.data.list,
                type: "csj",
            });
        },
        async tab_r_click(val) {
            this.tab_r_active = val;
            const res = await homepage_archivesList(this.getParameter(val, 8));
            this.$store.commit("SET_PAGE_LIST", {
                data: res.data.list,
                type: "ttxw",
            });
            this.$store.commit("SET_PAGE_LIST", {
                data: res.data.top,
                type: "ttxw_top",
            });
        },
        newbusMove(val) {
            this.yx_bus = val.province;
            if (val.school.length > 0) {
                this.yx_bus_school = val.school;
            } else {
                this.yx_bus_school = [];
            }
        },
        async pathInnerClick(val) {
            window.location.replace(
                `${process.env.VUE_APP_OUT_URL}${val.link}`
            );
            if (!val.ads_id) return;
            const res = await getAdsClick({
                sf: this.province,
                ads_id: val.ads_id,
            });
        },
        async pathOutClick(val) {
            if (val.ads_id == 834) {
                this.tabListClick(this.tab_list[0])
            } else {
                window.open(val.link, "_blank");
            }
            const res = await getAdsClick({
                sf: this.province,
                ads_id: val.ads_id,
            });
        },
        tabListClick(item) {
            if (item.is_open) {
                if (item.is_vip) {
                    let path = item.path
                        ? `${process.env.VUE_APP_OUT_URL}${item.path}`
                        : "https://h5.gkzzd.cn/wap/index/pre_inscription";
                    window.location.replace(path);
                } else {
                    if (this.$store.state.user.token) {
                        this.showTips = true;
                        this.showTipsContent = `您暂未开通【${item.business}】功能，开通系统即可体验`;
                        this.showTipsButton = "开通";
                    } else {
                        window.location.replace(
                            `${process.env.VUE_APP_OUT_URL}${this.$route.path}?openLogin=true`
                        );
                        // Message({
                        //     message: "接口签名失败",
                        //     type: "info",
                        // });
                    }
                }
            } else {
                this.showTips = true;
                this.showTipsButton = "确定";
                this.showTipsContent = `当前省份未开放【${item.business}】功能，敬请期待！`;
            }
        },
        SETTABLIST() {
            // homepage 初始是空字符串,解构会 undefined,加 || {} 降级
            const { moni = {}, wucha = {}, xuanke = {} } = this.$store.state.user.homepage || {};
            this.tabList[0].is_open = wucha.is_open;
            this.tabList[0].is_vip = wucha.is_vip;
            this.tabList[1].is_open = wucha.is_open;
            this.tabList[1].is_vip = wucha.is_vip;
            this.tabList[2].is_open = wucha.is_open;
            this.tabList[2].is_vip = wucha.is_vip;
            this.tabList[3].is_open = xuanke.is_open;
            this.tabList[4].is_open = moni.is_open;
            this.tabList[4].is_vip = moni.is_vip;
            this.tab_list[0].is_open = moni.is_open;
            this.tab_list[0].is_vip = moni.is_vip;
        },
        detailClick(val) {
            window.open(`/school/article?id=${val}`, "_blank");
        },
        isMobile() {
            const userAgent =
                navigator.userAgent || navigator.vendor || window.opera;
            // 常见的移动设备标志
            return (
                /android/i.test(userAgent) ||
                /iPhone|iPad|iPod/i.test(userAgent) ||
                /HarmonyOS/i.test(userAgent) ||
                /OpenHarmony/i.test(userAgent)
            );
        },
    },
    mounted() {
        this.$nextTick(() => this.checkEllipsis());
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_yxjs", "disabledListYxjs")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_zkgg", "disabledListZkgg")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_ttxw", "disabledListTtxw")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_rmzt", "disabledListRmzt")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_lnfs", "disabledListLnfs")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_zsjh", "disabledListZsjh")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_zszc", "disabledListZszc")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_sszs", "disabledListSszs")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_sshj", "disabledListSshj")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_mkfs", "disabledListMkfs")
        );
        this.$nextTick(() =>
            this.checkEllipsis("titleItem_yszy", "disabledListYszy")
        );
        this.$nextTick(() => {
            if (this.$store.state.user.homepage) {
                this.SETTABLIST();
                // 选完省份后重新拉取数据(省份变化会影响列表内容)
                this.refreshData();
            }
        });
        if (this.isMobile()) {
            window.location.href = "https://www.gkzzd.cn/h5";
        }
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .first {
        cursor: pointer;
        background: #fff;
        .left {
            padding: 0 20px 0 30px;
            .mainSearch {
                width: 100%;
                height: 40px;
                border: #3c78ff solid 1px;
                color: #999999;
                border-radius: 4px;
            }
            .mainButton {
                width: 80px;
                height: 40px;
                background: #3c78ff;
                color: #fff;
                border-radius: 4px;
            }
        }
        .right {
            height: 100%;
            font-size: 24px;
            color: #fff;
            background-color: #3c78ff;
            padding: 0 20px;
        }
    }
    .fourth {
        .tab_lisr {
            border: 1px solid #f5f5f5;
            border-top: 2px solid #f5f5f5;
            color: #999;
            padding: 10px 20px;
        }
        .tab_r_active {
            /* 基础边框 */
            border: 1px solid #f2f2f2;
            /* 顶部覆盖 */
            border-top: 2px solid #3c78ff;
            /* 底部去掉 */
            border-bottom: none;
            color: #000;
            padding: 10px 20px;
        }
    }
    .sixth {
        .border {
            border-right: 1px solid #ccc;
            &:last-child {
                border: none;
            }
        }
    }
    .seventh {
        .newBus {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(33px, 1fr));
            .title {
                background: #f5f4f4;
                border-bottom: 1px solid #c9c6c6;
            }
            .title_active {
                border: 1px solid #c9c6c6;
                border-bottom: none;
                background: #fff;
                color: red;
            }
        }
    }
    .tenth {
        .sjList {
            background: #3c78ff;
            color: #fff;
        }
    }
    .title_box {
        color: #3c78ff;
        border-bottom: 1px solid #e9e9e9;

        .title {
            border-left: 4px solid #3c78ff;
            display: block;
            text-indent: 9px;
            color: #000;
            font-weight: bold;
        }
    }
    .titleItem {
        font-weight: bold;
        &:hover {
            text-decoration: underline;
            color: red;
        }
    }
    .hover {
        &:hover {
            text-decoration: underline;
            color: red;
        }
    }
}
.provinceConfirm {
    background: #3c78ff;
    color: #fff;
    margin: 30px 0 0 0;
    border-radius: 15px;
}
</style>